// ─────────────────────────────────────────────────────────────────────────
// Shared constants used across multiple components.
// The ARENAS list is the canonical "seven areas of life" referenced in
// Foundations (as a reflection exercise) and in Goals (as a dropdown
// tying each intention to a life area).
// ─────────────────────────────────────────────────────────────────────────

export const ARENAS = [
  { key: 'body', label: 'Body & Health', hint: 'Physical state, energy, how you move, how you eat.' },
  { key: 'mind', label: 'Mind & Craft', hint: 'Work, career, what you are building or learning.' },
  { key: 'money', label: 'Money', hint: 'Income, savings, what you own, the freedom it gives.' },
  { key: 'home', label: 'Home', hint: 'Where you live. What it looks and feels like.' },
  { key: 'people', label: 'People', hint: 'Partner, family, friendships. The ones closest to you.' },
  { key: 'growth', label: 'Growth', hint: 'Learning, spiritual practice, what you are pursuing.' },
  { key: 'contribution', label: 'Contribution', hint: 'Community, service, your impact on others.' },
];

// Quick lookup by key → label (used for rendering arena tags).
export const ARENA_LABELS = ARENAS.reduce((acc, a) => ({ ...acc, [a.key]: a.label }), {});
